export default __webpack_public_path__ + "static/media/LOKALEAUSKUNFT.05a8fee7.png";